import * as React from "react";
import { useState, useEffect, useLayoutEffect, useRef } from "react";
import { FileValue } from ".";

interface InputBtnsProps {
    fileDescription: any;
    file: FileValue;
    toggleDescription: any;
    docId: string;
    onDelete?: any;
};

export const InputBtns = ({ fileDescription, file, toggleDescription, docId, onDelete }: InputBtnsProps) => {
    return (
        <div className="input-group-btn">
            {!!fileDescription && (
                <button type="button" onClick={() => toggleDescription(docId)} className="btn btn-default btn-add">
                    <span className="glyphicon glyphicon-question-sign" />
                </button>
            )}
            {file?.url && (
                <button
                    type="button"
                    className="btn btn-danger btn-remove"
                    onClick={() => onDelete(docId, file?.id)}
                >
                    Удалить
                </button>
            )}
        </div>
    )
};
